// extracted by mini-css-extract-plugin
module.exports = {"root":"GlobalHeaderLogo_root__pkRn7","desktopLogo":"GlobalHeaderLogo_desktopLogo__YZsnN","mobileLogo":"GlobalHeaderLogo_mobileLogo__U09EC"};